import {Routes} from '@angular/router';
import {NgcLoginComponent} from '@app/views/common/login/login.component';
import {MaintenanceGuard} from '@app/core/security/maintenance.guard';
import {ResetPasswordComponent} from '@app/views/common/reset-password/reset-password.component';
import {SetUserPasswordComponent} from '@app/views/common/set-password/set-password.component';
import {ForgotPasswordComponent} from '@app/views/common/forgot-password/forgot-password.component';
import {AuthSamlComponent} from '@app/views/common/login/auth-saml/auth-saml.component';
import {AuthOauthComponent} from '@app/views/common/login/auth-oauth/auth-oauth.component';
import {AuthErrorComponent} from '@app/views/common/login/auth-error/auth-error.component';
import {VersionComponent} from '@app/views/common/version/version.component';
import {NgcPrivacyPolicyComponent} from '@app/views/common/privacy-policy/privacy-policy.component';
import {NgcTermsOfUseComponent} from '@app/views/common/terms-of-use/terms-of-use.component';
import {MaintenanceComponent} from '@app/views/common/maintenance/maintenance.component';
import {LoginAsSelectorComponent} from '@app/views/common/login/login-as-selector/login-as-selector.component';
import {environment} from '@env/environment';
import {AccountExpiredComponent} from '@app/views/common/account-expired/account-expired.component';

// const MainLoginPage = CustomerService.checkIsAmplifyCustomer() ? NgcLoginComponent : LoginAsSelectorComponent;
const MainLoginPage = environment.stsServer ? LoginAsSelectorComponent : NgcLoginComponent;
const DistrictLoginPage = environment.stsServer ? MainLoginPage : NgcLoginComponent;

export const routes: Routes = [
    {
        path     : 'login',
        component: MainLoginPage,
        canActivate: [MaintenanceGuard],
        title: 'Sign In'
    },
    {
        path     : 'auth/login',
        component: MainLoginPage,
        canActivate: [MaintenanceGuard],
        title: 'Sign In'
    },
    {
        path     : 'login/district',
        component: DistrictLoginPage,
        canActivate: [MaintenanceGuard],
        data: {launchDistrictLogin: true},
        title: 'Sign In'
    },
    {
        path     : 'auth/login/district',
        component: DistrictLoginPage,
        canActivate: [MaintenanceGuard],
        data: {launchDistrictLogin: true},
        title: 'Sign In'
    },
    {
        path     : 'login/vendor',
        component: NgcLoginComponent,
        canActivate: [MaintenanceGuard],
        title: 'Sign In'
    },
    {
        path     : 'auth/login/vendor',
        component: NgcLoginComponent,
        canActivate: [MaintenanceGuard],
        title: 'Sign In'
    },
    {
        path     : 'login/mfa-setup',
        component: NgcLoginComponent,
        canActivate: [MaintenanceGuard],
        title: 'MFA Setup'
    },
    {
        path     : 'auth/reset-password',
        component: ResetPasswordComponent,
        title: 'Password Reset'
    },
    {
        path     : 'auth/set-password',
        component: SetUserPasswordComponent,
        title: 'Set Password'
    },
    {
        path     : 'account/forgot-password/account-setup',
        component: ForgotPasswordComponent,
        data: {accountSetup: true},
        title: 'Account Setup'
    },
    {
        path     : 'auth/forgot-password',
        component: ForgotPasswordComponent,
        title: 'Forgot Password'
    },
    {
        path     : 'auth/account-expired',
        component: AccountExpiredComponent,
        canActivate: [MaintenanceGuard],
        title: 'Account Expired'
    },
    {
        path     : 'auth/saml',
        component: AuthSamlComponent
    },
    {
        path     : 'auth/oauth',
        component: AuthOauthComponent
    },
    {
        path     : 'auth/error',
        component: AuthErrorComponent,
        title: 'Error'
    },
    {
        path     : 'version',
        component: VersionComponent,
        title: 'Version'
    },
    {
        path     : 'doc/privacy-policy/:bookmark',
        pathMatch: 'full',
        component: NgcPrivacyPolicyComponent,
        title: 'SchoolDay Privacy Policy'
    },
    {
        path: 'doc/privacy-policy',
        pathMatch: 'full',
        component: NgcPrivacyPolicyComponent,
        title: 'SchoolDay Privacy Policy'
    },
    {
        path     : 'doc/terms-of-use',
        component: NgcTermsOfUseComponent,
        title: 'SchoolDay Terms of Service for Schools'
    },
    {
        path     : 'maintenance/:testingaftermaintenance',
        component: MaintenanceComponent,
        title: 'Maintenance'
    },
    {
        path     : 'maintenance',
        component: MaintenanceComponent,
        title: 'Maintenance'
    }
];

export const loginRoutes: string[] = [
    '/login',
    '/auth/login',
    '/login/district',
    '/login/vendor',
    '/auth/login/district',
    '/auth/login/vendor',
    '/auth/oauth'
];

export const isLoginRoute = (path: string) =>
    loginRoutes.some((s: string) =>
        path.startsWith(s)
    );
